import React from 'react';
import {Route} from 'react-router-dom';
import AsyncFaq from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default (
  <Route
    key="/business/faq"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {position: 1, name: 'Home', item: '/'},
          {position: 2, name: 'Business', item: '/business'},
          {position: 3, name: 'Faq', item: '/business/faq'},
        ]}
      />
    }
  >
    {/* FIXME: :defaultType? now matches any value; invalid-value behavior pending demo verification */}
    <Route path="business/faq/:defaultType?" element={<AsyncFaq />} />
  </Route>
);
